import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const CategoriesTableRow = ({
    category,
    index,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language;
    const isArabic = lng.startsWith('ar');

    // جلب الاسم بناءً على اللغة المتوفرة
    const nameEn = category?.name?.en || category?.name?.ar || (typeof category?.name === 'string' ? category.name : '-');
    const nameAr = category?.name?.ar || category?.name?.en || (typeof category?.name === 'string' ? category.name : '-');

    const isSelected = selectedIds?.includes(category.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, category.id)}
                />
            </TableCell>

            {/* الرقم التسلسلي */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic ? nameAr : nameEn}
            </TableCell>

            {/* Slug */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                <Chip
                    label={category?.slug}
                    size="small"
                    variant="outlined"
                    sx={{ borderRadius: '6px', fontWeight: 'bold' }}
                />
            </TableCell>

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={category?.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    color={category?.is_active ? 'success' : 'error'}
                    size="small"
                    sx={{ borderRadius: '6px', minWidth: '70px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {category?.created_at ? dayjs(category.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, category)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default CategoriesTableRow;
